module.exports = __webpack_public_path__ + "img/oneBlue.d116b8f9.jpg";